import React, { useContext } from 'react';
import type { MaintenanceContextInterface } from './MaintenanceContext';
import MaintenanceContext from './MaintenanceContext';
import AppContext from '@aurora/shared-client/components/context/AppContext/AppContext';
import { EndUserPages } from '@aurora/shared-types/pages/enums';
import dynamic from 'next/dynamic';
import { MAINTENANCE_FLOATING_BOX_ID } from './MaintenanceFloatingBox';
import useFloatingBox from '@aurora/shared-client/components/context/FloatingBoxContext/useFloatingBox';

const MaintenanceFloatingBox = dynamic(() => import('./MaintenanceFloatingBox'), { ssr: false });

const MaintenanceContextProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const { community, pageTemplateContext } = useContext(AppContext);
  const { maintenanceProperties: { isMaintenanceModeEnabled = false } = {} } = community;
  const context: MaintenanceContextInterface = {
    isMaintenanceModeEnabled
  };

  const showMaintenanceBox =
    isMaintenanceModeEnabled &&
    pageTemplateContext.name !== EndUserPages.MaintenancePage &&
    pageTemplateContext.name !== EndUserPages.LoginPage;

  const { floatingBox, showBox } = useFloatingBox(MAINTENANCE_FLOATING_BOX_ID, {
    initiallyShowBox: showMaintenanceBox
  });

  return (
    <MaintenanceContext.Provider value={context}>
      {showBox && floatingBox(<MaintenanceFloatingBox />)}
      {children}
    </MaintenanceContext.Provider>
  );
};

export default MaintenanceContextProvider;
